"use client";

import { motion, type HTMLMotionProps } from "motion/react";
import { TRANSITION } from "./motion-tokens";

export interface FadeProps extends HTMLMotionProps<"div"> {
  speed?: keyof typeof TRANSITION;
}

export function Fade({ speed = "base", ...props }: FadeProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={TRANSITION[speed]}
      {...props}
    />
  );
}
